import { render, staticRenderFns } from "./WorkFloCallCard.vue?vue&type=template&id=459a7b7a&"
import script from "./WorkFloCallCard.vue?vue&type=script&lang=js&"
export * from "./WorkFloCallCard.vue?vue&type=script&lang=js&"
import style0 from "./WorkFloCallCard.vue?vue&type=style&index=0&id=459a7b7a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports